// Vue import retiré car non utilisé dans ce module

const state = {
  // État de navigation et de session
  currentCollectionId: null,
  currentBrandId: null,
  
  // État initial capturé (pour détecter les changements)
  initialState: {
    persistentSelection: [],
    articlesData: [],
    mode: 'auto', // 'auto' | 'manual'
    activeFilters: {},
    filters: {}
  },

  // État actuel
  currentState: {
    persistentSelection: [],
    articlesData: [],
    mode: 'auto',
    activeFilters: {},
    filters: {}
  },

  // État de l'interface
  ui: {
    loading: false,
    showCancelModal: false,
    selectionTableKey: 0
  }
};

const mutations = {
  // Navigation
  SET_CURRENT_COLLECTION(state, { collectionId, brandId }) {
    state.currentCollectionId = collectionId;
    state.currentBrandId = brandId;
  },

  // État initial (capture une seule fois)
  SET_INITIAL_STATE(state, initialState) {
    state.initialState = { ...initialState };
  },

  // État actuel
  SET_CURRENT_PERSISTENT_SELECTION(state, selection) {
    state.currentState.persistentSelection = [...selection];
  },

  SET_CURRENT_ARTICLES_DATA(state, data) {
    state.currentState.articlesData = [...data];
  },

  SET_CURRENT_MODE(state, mode) {
    state.currentState.mode = mode;
  },

  SET_CURRENT_ACTIVE_FILTERS(state, filters) {
    state.currentState.activeFilters = { ...filters };
  },

  SET_CURRENT_FILTERS(state, filters) {
    state.currentState.filters = { ...filters };
  },

  // UI
  SET_LOADING(state, loading) {
    state.ui.loading = loading;
  },

  SET_CANCEL_MODAL(state, show) {
    state.ui.showCancelModal = show;
  },

  INCREMENT_TABLE_KEY(state) {
    state.ui.selectionTableKey++;
  },

  // Reset complet de l'état
  RESET_STATE(state) {
    state.currentCollectionId = null;
    state.currentBrandId = null;
    state.initialState = {
      persistentSelection: [],
      articlesData: [],
      mode: 'auto',
      activeFilters: {},
      filters: {}
    };
    state.currentState = {
      persistentSelection: [],
      articlesData: [],
      mode: 'auto',
      activeFilters: {},
      filters: {}
    };
    state.ui = {
      loading: false,
      showCancelModal: false,
      selectionTableKey: 0
    };
  },

  // Restaurer l'état actuel vers l'état initial
  RESTORE_TO_INITIAL_STATE(state) {
    state.currentState = { ...state.initialState };
  }
};

const actions = {
  // Initialiser la session article selector
  initializeArticleSelector({ commit }, { collectionId, brandId }) {
    commit('SET_CURRENT_COLLECTION', { collectionId, brandId });
    commit('RESET_STATE');
  },

  // Capturer l'état initial (appelé une seule fois au chargement)
  captureInitialState({ commit }, stateData) {
    const initialState = {
      persistentSelection: [...(stateData.persistentSelection || [])],
      articlesData: [...(stateData.articlesData || [])],
      mode: stateData.mode || 'auto',
      activeFilters: { ...(stateData.activeFilters || {}) },
      filters: { ...(stateData.filters || {}) }
    };
    
    commit('SET_INITIAL_STATE', initialState);
    // Également mettre à jour l'état actuel
    commit('SET_CURRENT_PERSISTENT_SELECTION', initialState.persistentSelection);
    commit('SET_CURRENT_ARTICLES_DATA', initialState.articlesData);
    commit('SET_CURRENT_MODE', initialState.mode);
    commit('SET_CURRENT_ACTIVE_FILTERS', initialState.activeFilters);
    commit('SET_CURRENT_FILTERS', initialState.filters);
  },

  // Mettre à jour la sélection
  updateSelection({ commit }, selection) {
    commit('SET_CURRENT_PERSISTENT_SELECTION', selection);
  },

  // Mettre à jour les filtres
  updateFilters({ commit }, filters) {
    commit('SET_CURRENT_ACTIVE_FILTERS', filters);
  },

  // Mettre à jour le mode
  updateMode({ commit }, mode) {
    commit('SET_CURRENT_MODE', mode);
  },

  // Restaurer vers l'état initial
  restoreToInitialState({ commit }) {
    commit('RESTORE_TO_INITIAL_STATE');
  },

  // Nettoyer la session
  cleanupSession({ commit }) {
    commit('RESET_STATE');
  }
};

const getters = {
  // Vérifier s'il y a des changements non sauvegardés
  hasUnsavedChanges: (state) => {
    const initial = state.initialState;
    const current = state.currentState;

    // Comparer les sélections
    const selectionChanged = !arraysEqual(initial.persistentSelection, current.persistentSelection);
    
    // Comparer les filtres
    const filtersChanged = JSON.stringify(initial.activeFilters) !== JSON.stringify(current.activeFilters);
    
    // Comparer le mode
    const modeChanged = initial.mode !== current.mode;

    return selectionChanged || filtersChanged || modeChanged;
  },

  // État actuel
  currentSelection: (state) => state.currentState.persistentSelection,
  currentMode: (state) => state.currentState.mode,
  currentFilters: (state) => state.currentState.activeFilters,
  
  // État initial
  initialSelection: (state) => state.initialState.persistentSelection,
  initialMode: (state) => state.initialState.mode,
  initialFilters: (state) => state.initialState.activeFilters,

  // UI
  isLoading: (state) => state.ui.loading,
  showCancelModal: (state) => state.ui.showCancelModal,
  tableKey: (state) => state.ui.selectionTableKey
};

// Helper function
function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};